import { yo } from 'models/CommentedAnswer';
import Form from './Form';

export interface IALIDataJson {
  [key: string]: string;
}

class ALI extends Form {
  // concreteSituation?: string;
  // personalData?: string;
  // description?: string;
  // listPessoalData?: string;
  // activityConcreteYes?: any;
  // resultWasChanged?: any;
  // resultWasChangedObs?: string;
  // reportIsNeeded?: any;
  // reportIsNeededObs?: string;
  // jsonCustomObs?: any;
  // processingOfRelevantConceptsAndActivity?: any;

  // activityDataSources?: yo = 'no';
  // activities?: string = 'O projeto não envolve o tratamento de dados sensíveis';
  // activityLicit?: yo = 'no';
  // activityConcrete?: yo = 'no';
  // actitivyLessData?: yo = 'no';
  // actitivyPrivicyData?: yo = 'no';
  // actitivyHappens?: yo = 'no';
  // actitivyKnowns?: yo = 'no';

  actitivyHappens: yo = '';
  actitivyKnowns: yo = '';
  actitivyLessData: yo = '';
  actitivyPrivicyData: yo = '';
  activityConcrete: yo = '';
  activityLicit: yo = '';
  reportIsNeeded: yo = '';
  resultWasChanged: yo = '';
  activities?:
    | 'o projeto trata dados pessoais sensíveis'
    | 'o projeto não trata dados pessoais sensíveis';

  activityConcreteYes?: string;
  activityDataSources?: string = 'no';
  concreteSituation?: string;
  personalData?: string;
  reportIsNeededObs?: string;
  resultWasChangedObs?: string;
  jsonCustomObs = '';
  jsonCustomObsObj: IALIDataJson = {};
}

export default ALI;

export interface IALIResult {
  risk?: {
    answers: {
      empty: boolean;
    };
    color: string;
    message: string;
  };
  resultWasChanged?: any;
  resultWasChangedObs?: string;
  reportIsNeeded?: any;
  reportIsNeededObs?: string;
  id: any;
  conclusion?: any;
}
